import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized } from '@angular/router';

import { AuthService, DataService,APP_STORAGE_FIRSTNAME } from '../shared';
import {ReferenceTableService} from "../reference-table.service";


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  showHeaderControls: boolean;
  isNavbarCollapsed: boolean;
  routeEventsSubscription: any;
  firstName: string;
  navRequired: boolean = true;
  show:Boolean;
  innerDisable = true;
  logoLink: string;
  DataService;
  constructor(
    private dataService: DataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private data: ReferenceTableService,
  ) {
    this.showHeaderControls = false;
    this.isNavbarCollapsed = true;
    this.navRequired = false;
  }

  ngOnInit(){

    this.data.currentFirstName.subscribe(
      (message) => {
        this.firstName = message;
      });
      if(sessionStorage.getItem("FirstName")){
        this.navRequired = true;
      }
      else{
        this.navRequired = false;
      }
    //Event for Route change
    this.router.events.subscribe((event) => {
      //Event: When route navigation has ended
      //this.navRequired = (event.state.root.firstChild.data['navRequired'] !== undefined) ? event.state.root.firstChild.data['navRequired'] : true;
      if(event instanceof RoutesRecognized) {
        this.showHeaderControls = (event.state.root.firstChild.data['showHeaderControls'] !== undefined) ? event.state.root.firstChild.data['showHeaderControls'] : true;
        this.navRequired = (event.state.root.firstChild.data['navRequired'] !== undefined) ? event.state.root.firstChild.data['navRequired'] : true;
      }
      if (this.router.url === '/reset' && this.dataService.getSharedDataObject().get("tempPasswordSw") === 'Y') {
        this.innerDisable = false;
        this.logoLink = '/SNAPWorks/providerportal';
      } else {
        this.innerDisable = true;
        this.logoLink = '/SNAPWorks/providerportal';
      }
    });
  }

  ngOnDestroy() {
    this.routeEventsSubscription.unsubscribe();
  }

  collapseNavbar() {
    this.isNavbarCollapsed = true;
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  processSignOut(){
    this.dataService.sharedDataMap = new Map<string, any>();
    this.authService.signOut();
    this.navRequired = false;
    sessionStorage.removeItem("firstName");
    localStorage.clear();
    this.router.navigate(['SNAPWorks/providerportal']); 
  }
  
  processReset(){
    this.router.navigate(['reset']);
  }
  onClickedOutside(e: Event) {
    if(this.show == true){
      this.show = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts